export class InventoryCountTag {
    invCountTagId: number;
    invCountId: number;
    code: string;
    name: string;
    countValidation: number;
    count: number;
    canDelete: boolean;
}
